import { render, staticRenderFns } from "./dashbored.vue?vue&type=template&id=4c8cafef&scoped=true&"
import script from "./dashbored.vue?vue&type=script&lang=js&"
export * from "./dashbored.vue?vue&type=script&lang=js&"
import style0 from "./dashbored.vue?vue&type=style&index=0&id=4c8cafef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8cafef",
  null
  
)

export default component.exports